
import { Injectable } from '@angular/core';
import { Client, ClientLocation, ClientNote, ClientNoteType, PropertyNote, ClientVendorCreds, AlternateScoringModel, ScoringModelLocationAssignment} from '../models/clientLocation';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SearchPackage } from '../../packages-module/models/searchPackage';
import { UserLight } from '../../users-module/models/userLight';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { ObjectUpdatePayload } from '../../models/screeningInvite';
import { ClientFilter } from '../models/ClientFilter';
import { environment } from 'src/environments/environment';
import { FilteringService } from '../../services/filtering.service';
import { Address } from '../../models/Address';
import { SimpleDataFilter } from '../../models/simpleDataFilter';
import {PaginationService} from '../../shared-components-module/pagination-top/services/pagination.service';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  public loading : boolean = false;
  public clients : Array<Client>;
  currentClient : Client;
  currentClientLocations: Array<ClientLocation>;
  activeClientLocation : ClientLocation;
  currentClientPackages: Array<SearchPackage>;
  loggedInUserPackages : Array<SearchPackage>; // FOR a CRA that is logged in so we can track their pkgs and the client in question.
  public clientLoaded : Subject<boolean> = new Subject<boolean>();
  public clientsLoaded : Subject<boolean> = new Subject<boolean>();
  public locationsLoaded : Subject<boolean> = new Subject<boolean>();
  inClientSetup : boolean;
  filtertype : string = "client";
  onlyActiveClients : boolean;
  editMode : boolean = false;
  clientFilter : ClientFilter = new ClientFilter();
  clientUsers : Array<UserLight> = [];
  totalClientCount : number;
  validBillingCodes : any[] = [
    {val :'WRT', rqrd: true},
    {val :'RIQ',  rqrd: true},
    {val :'RSM', rqrd: false},
    {val :'PBS', rqrd: false},
  ];

  constructor(private http : HttpClient, public toast: ToastrService, private auth : AuthService, private filters : FilteringService,
              private readonly paginationService: PaginationService) {

  }

  apiPartner : any[] =  [
    { name: 'None', id: null },
    { name: 'TenantTech', id: 0 },
    { name: 'Testing', id: 1 },
    { name: 'Aptexx', id: 2 },
    { name: 'Property Boss', id: 3 },
    { name: 'Bacon', id: 4 },
    { name: 'OneApp Gaurantee', id: 5 },
    { name: 'Rent Manager', id: 6 },
    { name: 'ResMan', id: 7 },
    { name: '365 Connect', id: 8 },
    { name: 'Eastman', id: 10 },
    // { name: 'Yardi', id: 9 },

  ];

  public get keys() : Array<string> {
    var keys = Object.keys(ClientNoteType);
    return keys;//.slice(keys.length / 2);
  }

  SetActiveClient(clnt : Client){
    if(!this.currentClient || this.currentClient.id != clnt.id){
      this.currentClient = clnt;
      this.clientLoaded.next(true);
    }else{
      this.clientLoaded.next(true);
    }

  }
  
  FetchLightClientList() : Observable<Client[]> {
    return this.http.get<Client[]>(environment.baseURl + `/api/client/list/light`);
  }

  FetchSignalRSubs(): Observable<number[]> {
    return this.http.get<number[]>(environment.baseURl + `/api/client/signalrsubs`);
  }

  // Calls to Keep ===========================
  FetchClientList(filters : ClientFilter) {
    var offset = (this.paginationService.currentPage -1) * this.paginationService.pageIncrement;

    this.loading = true;
      this.http.post<Array<Client>>(environment.baseURl + `/api/client/list/${this.paginationService.pageIncrement}/${offset}`, filters).subscribe(
        (scc : any)=>{
          this.clients = scc.listResult.map(clnt => {
            return Object.assign(new Client() ,clnt);
          });
          this.totalClientCount = scc.totalRecordsCount;
          this.loading = false;
          this.currentClient = this.clients[0];
        },
        (err : any)=>{
          this.loading = false;
          this.toast.error('There was an error fetching your clients.', '', { disableTimeOut: true, closeButton: true});
        });
  }

  GetClientById(clientId : number) : Observable<Client> {
    return this.http.get<Client>(environment.baseURl + `/api/client/fetch/${clientId}`);
  }

  // END Calls to Keep ===========================

  // GetSearchTypes(): Observable<Object>{
  //   return this.http.get(environment.baseURl + `/api/search/searches`)
  // }

  GetClientCustomSearches(clientId : number) {
    return this.http.get(environment.baseURl + `/api/search/custom-search/${clientId}`);
  }

  AddClientAddress(pkg: Address){
    return this.http.post<number>(environment.baseURl + '/api/client/address/add', pkg);
  }

  SaveClient(clnt : Client): Observable<Object>{
    return this.http.post(environment.baseURl + '/api/client/save', clnt);
  }


  UpdateClientSingle(updates : Client){
    return this.http.post(environment.baseURl + `/api/client/update`,updates)
  }

  DeactivateClient(clientId : number){
    return this.http.get(environment.baseURl + `/api/client/deactivate/` + clientId);
  }

  SaveAlternateScoringModel(model: AlternateScoringModel) {
    return this.http.post(environment.baseURl + '/api/client/models', model);
  }

  UpdateAlternativeScoringModel(model: AlternateScoringModel) {
    return this.http.post(environment.baseURl + '/api/client/models/update', model);
  }

  GetAlternativeScoringModels(clientId: number) {
    return this.http.get<AlternateScoringModel[]>(environment.baseURl + '/api/client/models/' + clientId);
  }

  GetAlternativeScoringModelsByLocationId(locationId: number) {
    return this.http.get<AlternateScoringModel[]>(environment.baseURl + '/api/client/models/location/' + locationId);
  }

  GetAlternativeScoringModelAssignments(modelId: number) {
    return this.http.get<ScoringModelLocationAssignment[]>(environment.baseURl + '/api/client/models/assignment/' + modelId);
  }

  SaveAltScoringModelAssignments(models:ScoringModelLocationAssignment[]) {
    return this.http.post<ScoringModelLocationAssignment[]>(environment.baseURl + '/api/client/models/assignment', models);
  }
  RemoveAltScoringModelAssignments(models:ScoringModelLocationAssignment[]) {
    return this.http.post<ScoringModelLocationAssignment[]>(environment.baseURl + '/api/client/models/assignment/remove', models);
  }
  UpdateDefaultModelAssignments(models:ScoringModelLocationAssignment[]) {
    return this.http.post<ScoringModelLocationAssignment[]>(environment.baseURl + '/api/client/models/updateDefaults', models);
  }

}
